import axios from 'axios'
// export const BASEURL = ''
export const BASEURL = process.env.BASE_URL;
export const uploadImageURL = BASEURL + '/pc/upload/uploadImage'
export const ueditorURL = BASEURL + '/ueditor/UEditorConfig'

export const ajax = function (myurl, data = {}, type = 'GET', title = '', flag = true) {
  let url;
  if (flag) {
    url = BASEURL + myurl
  } else {
    url = myurl
  }
  // if(myurl.splice(0,5) == 'https'){
  //   url = myurl
  // }else{
  //   url = BASEURL + myurl
  // }

  return new Promise(function (resolve, reject) {
    let promise
    if (type === 'GET') {
      let paramstr = ''
      Object.keys(data).forEach(key => {
        paramstr += key + '=' + data[key] + '&'
      });
      if (paramstr !== '') {
        paramstr = paramstr.substring(0, paramstr.lastIndexOf('&'))
        url += '?' + paramstr
      }
      promise = axios.get(url)
    } else {
      if (title === 'img') {
        promise = axios.post(url, data, { headers: { 'Content-Type': 'multipart/form-data' } })
      } else {
        promise = axios.post(url, data)
      }
    }
    promise.then(function (response) {
      resolve(response.data)
    }).catch(function (err) {
      reject(err)
    })
  })
}

export const upload = function (url, data) {
  return new Promise(function (resolve, reject) {
    let promise
    let config = {
      headers: { 'Content-Type': 'multipart/form-data' }
    }
    promise = axios.post(url, data, config)
    promise.then(function (response) {
      resolve(response.data)
    }).catch(function (err) {
      reject(err)
    })
  })
}
// 文件导出
export const exportFileRequest = (url, params) => {
  return axios({
    method: 'get',
    url: `${BASEURL}${url}`,
    params: params,
    responseType: 'blob',
    headers: {

    }
  });
};



// WEBPACK FOOTER //
// ./src/assets/js/ajax.js